import { axiosInstance } from "../axiosInstance"
import { ADD_USER_API_ENDPOINT } from "../../helpers/config"
import { signUpData } from "../../helpers/commonInterface"

export const signUpService = (data : signUpData) => {
    return axiosInstance.post(ADD_USER_API_ENDPOINT, data)
}